(function(){
  const searchToggle = document.getElementById('search-toggle');
  const searchClose = document.getElementById('search-close');
  

  searchToggle.addEventListener('click', function(ev){
    ev.preventDefault();

    if(this.getAttribute('aria-expanded') === "true"){
      this.setAttribute('aria-expanded', 'false');
    }else{
      this.setAttribute('aria-expanded', 'true');
      document.querySelector('.desktop-search input').focus();
    }
  });

  searchClose.addEventListener('click', function(ev){
    ev.preventDefault();
    searchToggle.setAttribute('aria-expanded', 'false');
  });
})();